'use client';

import { OrderTabsCustomer } from '@/components/sections/builder/elements/body/customer/customer_order/component/tabs';
import { CustomerOrderElementDataType } from '@/components/sections/builder/elements/body/customer/customer_order/type';
import { ElementProps } from '@/components/sections/builder/types';
import React from 'react';

export default function ELementContentCustomerOrder({ element, preview }: ElementProps) {
  const content = element.data as CustomerOrderElementDataType;

  return (
    <>
      <div className='bg_scheme_customer_order customer_order_padding w-full'>
        <div className='theme_layout_page_width mx-auto flex flex-col gap-3 px-5'>
          <h1 className='text-2xl font-medium'>Order History</h1>
          <div className='w-full'>
            <OrderTabsCustomer content={content} preview={preview} />
          </div>
        </div>
      </div>
      <style jsx>
        {`
          .bg_scheme_customer_order {
            background-color: ${content.colorScheme?.background || 'white'};
            color: ${content.colorScheme?.text || '#52535B'};
          }
          .customer_order_padding {
            padding-top: ${content.topPadding}px;
            padding-bottom: ${content.bottomPadding}px;
          }
        `}
      </style>
    </>
  );
}
